import type { ReactNode } from 'react';
import { tokens } from './tokens';

type Variant = 'success' | 'error' | 'info';

type Props = Readonly<{
  variant: Variant;
  title?: string;
  children: ReactNode;
}>;

const palette: Record<Variant, { bg: string; border: string; text: string }> = {
  success: { bg: tokens.successBg, border: tokens.successBorder, text: tokens.successText },
  error: { bg: tokens.errorBg, border: tokens.errorBorder, text: tokens.errorText },
  info: { bg: tokens.infoBg, border: tokens.infoBorder, text: tokens.infoText },
};

/**
 * Opinionated inline alert. Three variants only — no icons, no dismiss button,
 * no custom colors. Renders a tinted box matching the auth-flow patterns.
 */
export function FormAlert({ variant, title, children }: Props): JSX.Element {
  const colors = palette[variant];
  const style = {
    background: colors.bg,
    border: `1px solid ${colors.border}`,
    color: colors.text,
  };
  const body = (
    <>
      {title && <p className="font-medium mb-1">{title}</p>}
      <div className="text-xs leading-relaxed">{children}</div>
    </>
  );

  if (variant === 'error') {
    return (
      <div role="alert" className="p-4 rounded-lg text-sm" style={style}>
        {body}
      </div>
    );
  }
  return (
    <output className="block p-4 rounded-lg text-sm" style={style}>
      {body}
    </output>
  );
}
